import { Badge, Group, Tabs, Text } from '@mantine/core';
import type { TabMetadata } from '@mdev/common';

interface TabNavigationProps {
  activeTab: string;
  onTabChange: (tabId: string) => void;
  tabMetadata: TabMetadata[];
  tabCounts: { [tabId: string]: { found: number; total: number } };
}

const coverageColor = (pct: number) => {
  if (pct === 100) return 'green';
  if (pct >= 75) return 'blue';
  if (pct >= 50) return 'yellow';
  return 'red';
};

export function TabNavigation({
  activeTab,
  onTabChange,
  tabMetadata,
  tabCounts,
}: TabNavigationProps) {
  return (
    <Tabs
      value={activeTab}
      onChange={(value) => {
        if (value) {
          onTabChange(value);
          window.location.hash = value;
        }
      }}
      variant="outline"
      keepMounted={false}
    >
      <Tabs.List>
        {tabMetadata.map((tab) => {
          const counts = tabCounts[tab.id] || { found: 0, total: 0 };
          const percentage =
            counts.total > 0 ? Math.round((counts.found / counts.total) * 100) : 0;

          return (
            <Tabs.Tab key={tab.id} value={tab.id} miw={120}>
              <Group gap="xs" wrap="nowrap">
                <div>
                  <Text size="sm" fw={500}>
                    {tab.shortName}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {counts.found}/{counts.total}
                  </Text>
                </div>
                <Badge color={coverageColor(percentage)} variant="light" size="sm">
                  {percentage}%
                </Badge>
              </Group>
            </Tabs.Tab>
          );
        })}
      </Tabs.List>
    </Tabs>
  );
}
